import React from 'react';
import type { FC } from 'react';
import { Box, Link, PointerIcon, Text } from '@wix/cli-ui-kit';

export const DeprecationMessage: FC = () => {
  return (
    <Box flexDirection="column" margin={1}>
      <Text skin="warning" bold>
        ⚠️ Deprecation Notice
      </Text>
      <Box
        flexDirection="column"
        gap={1}
        padding={1}
        borderColor="yellowBright"
        borderStyle="single"
        borderTop={true}
        borderLeft={false}
        borderBottom={true}
        borderRight={false}
      >
        <Text>
          The{' '}
          <Text bold skin="warning">
            @wix/app
          </Text>{' '}
          command is being deprecated. Please use the new command instead.
        </Text>
        <Text>Here's what to use instead:</Text>
        <Text skin="info">
          <PointerIcon appearance="triangle" /> npm create @wix/new@latest app
        </Text>
        <Text>
          Learn more:{' '}
          <Link url="https://dev.wix.com/docs/build-apps/get-started/quick-start/create-an-app-with-the-wix-cli" />
        </Text>
      </Box>
    </Box>
  );
};
